import { postRequest } from './index.js'

export const getOrdersByCustomerOrResearchNo = async ({ type, no, afterSales }) => {
  return postRequest('/hub-api/getCustomerOrders', { params: { type, no, afterSales: String(afterSales) === '1' } })
}

export const getOrderDetail = async (orderNo) => {
  return postRequest('/hub-api/getOrderDetail', { orderNo: orderNo })
}

// 查询订单产品详情
export const getOrderProductInfos = async (params) => {
  return postRequest('/hub-api/getOrderProductInfos', { params: params })
}

// 组装订单信息（用于未生成合同订单）
export const assembleOrders = async (orderId) => {
  return postRequest('/hub-api/assembleOrders', { orderId })
}

// 查询订单开票信息
export const getOrderInvoiceInfos = async (orderNo) => {
  return postRequest('/hub-api/getOrderInvoiceInfos', { orderNo })
}

// 获取元数据信息
export const getMerchandiseMeta = async () => {
  return postRequest('/hub-api/getMerchandiseMeta', null, false)
}

// 下载订单的合同文本
export const downloadOrderTextFile = async (orderId, orderNo, orderSource) => {
  window.open(`hub-api/downloadOrderText?orderNo=${orderNo}&orderId=${orderId}&orderSource=${orderSource}`)
}

// 查询合同进展（工具类）
export const getToolProgressInfoByContractNo = async (contractNo) => {
  return postRequest('/hub-api/getProgressInfoByContractNo', { contractNo })
}

// 查询进展（服务类）
export const getServiceProgressInfoByOrderNo = async (orderNo) => {
  return postRequest('/hub-api/getProgressInfoByOrderNo', { orderNo })
}

// 获取物流信息
export const getExpressTrack = async (contractNos) => {
  return postRequest('/hub-api/getExpressTrack', { contractNos })
}

// 下载出货单
export const downloadExpressOutFile = async (contractNo) => {
  window.open(`hub-api/GetExpressOutSheet?contractNo=${contractNo}`)
}

// 获取订单实物信息
export const getCustomerGoodsByContractNos = async (contractNos) => {
  return postRequest('/hub-api/getCustomerGoodsByContractNos', { contractNos })
}
export const getOrderItem = async (id) => {
  return postRequest(`/hub-api/getOrderItem?id=${id}`)
}
export const getVectorMapFile = async (id) => {
  return postRequest(`/hub-api/getVectorMapFile?id=${id}`)
}



// WEBPACK FOOTER //
// ./src/emktcommon/api/orderApi.js